import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { apiUrl } from '../config/api';
import './MemberVerify.css';

function MemberVerify() {
  const { memberId } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      setData(null);
      try {
        const res = await fetch(apiUrl(`/public/member/${encodeURIComponent(memberId || '')}`));
        const json = await res.json();
        if (cancelled) return;
        setData(json);
        if (!json.valid) {
          setError(json.message || json.error || 'Invalid or inactive member ID');
        }
      } catch (e) {
        if (!cancelled) setError(e.message || 'Network error');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [memberId]);

  return (
    <div className="mverify-page">
      <div className="mverify-shell">
        <Link className="mverify-back" to="/login">
          ← Sangram Sena
        </Link>

        <div className="mverify-card">
          {loading ? (
            <p className="mverify-muted">Verifying…</p>
          ) : data?.valid ? (
            <>
              <div className="mverify-badge valid">Verified member</div>
              <h1 className="mverify-title">{data.name}</h1>
              <dl className="mverify-dl">
                <div>
                  <dt>Member ID</dt>
                  <dd>{data.memberId}</dd>
                </div>
                <div>
                  <dt>Role</dt>
                  <dd>{data.role}</dd>
                </div>
                <div>
                  <dt>Area</dt>
                  <dd>{data.area}</dd>
                </div>
              </dl>
              <p className="mverify-footnote">
                This page confirms an active Sangram Sena volunteer record at the time of scan.
              </p>
            </>
          ) : (
            <>
              <div className="mverify-badge invalid">Not verified</div>
              <h1 className="mverify-title">Member could not be verified</h1>
              <p className="mverify-desc">{error || 'No active record for this ID.'}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MemberVerify;
